import { supabase } from "../supabase/supabase";

interface IHand {
    game?: string;
    player?: number;
    indicesStr?: string;
    indices?: number[];
    leadingCardIdx?: number;
}

export class Hand {
    game: string;
    player: number;
    indicesStr: string;
    indices: number[];
    leadingCardIdx: number;

    constructor(game: string, player: number, indicesStr: string, indices: number[], leadingCardIdx: number) {
        this.game = game;
        this.player = player;
        this.indicesStr = indicesStr;
        this.indices = indices;
        this.leadingCardIdx = leadingCardIdx;
    }

    setLeadingCardIdx(newIdx: number) {
        this.leadingCardIdx = newIdx;
    }

    static getIndices(handIndicesStr: string) {
        const handIndices = [];
        if (handIndicesStr.length > 0) {
            handIndicesStr = handIndicesStr.substring(0, handIndicesStr.length - 1); // remove the last comma
        }
        const indicesList = handIndicesStr.length === 0 ? [] : handIndicesStr.split(",");
        for (let idx = 0; idx < indicesList.length; idx++) {
            handIndices.push(Number(indicesList[idx]));
        }
        return handIndices;
    }

    static fromJson(json: IHand) {
        const gameId = json.game ? json.game as string : "";
        const playerId = json.player ? json.player as number : 0;
        const handIndicesStr = json.indicesStr ? json.indicesStr as string : "";
        const handIndices = this.getIndices(handIndicesStr);
        return new Hand(
            gameId,
            playerId,
            handIndicesStr,
            handIndices,
            0
        );
    }

    static async addNewHand(gameId: string, playerId: number) {
        const { data, error } = await supabase
            .from("Hands")
            .insert({
                game: gameId,
                player: playerId,
                indicesStr: "",
            });
    }

    static async updateHand(playerId: number, handIndicesStr: string) {
        const { error } = await supabase
            .from("Hands")
            .update({ indicesStr: handIndicesStr })
            .eq("player", playerId);
    }

    static async getHands(gameId: string) {
        const hands = [];
        const { data, error } = await supabase
            .from("Hands")
            .select(`
                player,
                indicesStr
                `)
            .eq("game", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const hand = this.fromJson(data![idx]);
            hands.push(hand);
        }

        return hands;
    }

    static async getHand(playerId: number) {
        const hands = [];
        const { data, error } = await supabase
            .from("Hands")
            .select(`
                player,
                indicesStr
                `)
            .eq("player", playerId);

        for (let idx = 0; idx < data!.length; idx++) {
            const hand = this.fromJson(data![idx]);
            hands.push(hand);
        }
        
        if (hands.length > 0) {
            return hands[0];
        }
        return new Hand("", playerId, "", [], 0);
    }
}